<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>


import Model from '@/model/index'
import {mapState, mapMutations} from 'vuex'

export default {
  computed: {
    ...mapState(['navigationList'])
    },
  data() {
    return {
      timer: null,
      screenWidth: '',
    }
  },
  mounted() {
  },
  created() {
    this.getNavigation()
  },
  methods: {
    ...mapMutations(['setNavigationList']),
    async getNavigation(){
      if(this.navigationList.length === 0) {
        const res = await Model.getNavigation()
        if(res.code === 1 && res.data.length > 0) {
          this.setNavigationList(res.data)
        }
      }
    }
  },
  watch: {
  },
}
</script>

<style lang="scss">

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  //font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  font-family: "PingFang SC-Regular", "PingFang SC",sans-serif;

}
.ql-align-right{
  text-align: right;
}

.ql-align-center{
  text-align: center;
}

.ql-align-justify{
  text-align: justify;
}
</style>
